export function getResistantLabel(rating: 0 | 1): string {
  switch (rating) {
    case 0:
      return `highly resistant`;
    case 1:
      return `resistant`;
  }
}
